import { useMutation } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import {
  assertEngineEarsErrorType,
  displayEngineEarsError,
} from "../../helpers";
import {
  uploadReleaseTrack,
  UploadReleaseTrackArgs,
} from "../uploadReleaseTrackAPI";
import { useAtomValue } from "jotai";
import { uploadReleaseTrackStateAtom } from "../../../atoms/releases/uploadReleaseTrackAtom";

export const useUploadReleaseTrack = (releaseId = 0) => {
  const { releaseTrackId, failedReleaseTrackId } = useAtomValue(
    uploadReleaseTrackStateAtom,
  );

  return useMutation({
    mutationKey: [QUERY_KEYS.UPLOAD_RELEASE_TRACK, releaseId],
    mutationFn: async (args: UploadReleaseTrackArgs) => {
      return uploadReleaseTrack(releaseId, {
        ...args,
        ...(releaseTrackId || failedReleaseTrackId
          ? { releaseTrackId: releaseTrackId || failedReleaseTrackId }
          : {}),
      });
    },
    onError: (error) => {
      if (assertEngineEarsErrorType(error)) {
        displayEngineEarsError(error);
      }
    },
  });
};
